<template>
    <b-modal
        :id="keyName"
        :ref="keyName"
        :title="title"
        :ok-disabled="disabled"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()"
        modal-class="apprentice-default modal">
        <!-- ovg -->
        <div
            class="ovg-rating"
            v-if="rating.type === 1">
            <div class="rating-options">
                <label class="rating-label">OVG</label>
                <div class="options">
                    <b-button-group>
                        <b-button
                            v-for="ratingOption in rating.options"
                            :key="ratingOption.id"
                            active-class="active"
                            :active="ratingOption.id === ovg"
                            @click="ovgToggle(ratingOption.id)"
                            :variant="ratingOption.id === ovg ? 'primary' : 'outline-primary'">
                            {{ ratingOption.value }}
                        </b-button>
                    </b-button-group>
                </div>
            </div>

            <div
                class="sub-assignments-rating"
                v-if="filteredChildren && filteredChildren.length">
                <h5>{{ childTitle }}</h5>

                <div
                    class="sub-assignment-rating"
                    v-for="child in filteredChildren"
                    v-if="children && children.length">
                    <div class="sub-assignment-name">
                        {{ child.name }}
                    </div>
                    <div
                        class="sub-assignment-rating-vlue"
                        v-if="getChildValue(child)">
                        {{ getChildValue(child) }}
                    </div>
                    <div
                        class="not-yet-rated"
                        v-else>
                        {{ $t('portfolio.not_assessed') }}
                    </div>
                </div>
            </div>
        </div>

        <!-- grade -->
        <div
            class="grade-rating"
            v-if="rating.type === 2">
            <div class="grade-options">
                <label for="assignment-grade">{{ $t('portfolio.grade') }}</label>
                <b-form-input
                    class="assignment-grade"
                    id="assignment-grade"
                    v-model="grade"
                    type="number"></b-form-input>
            </div>

            <div
                class="sub-assignments-grade"
                v-if="filteredChildren && filteredChildren.length">
                <h5>{{ childTitle }}</h5>
                <div
                    class="row grades"
                    v-if="allGrades">
                    <div class="col-md-6"></div>
                    <div class="col-md-2 number">{{ $t('portfolio.grade') }}</div>
                    <div class="col-md-2 weight">{{ $t('portfolio.weight') }}</div>
                    <div class="col-md-2 result">{{ $t('portfolio.result') }}</div>
                </div>

                <div
                    class="row sub-assignment-grade"
                    v-for="child in filteredChildren"
                    v-if="children && children.length">
                    <div class="col-md-6">
                        {{ child.name }}
                    </div>
                    <div
                        class="col-md-2"
                        v-if="getChildValue(child)">
                        {{ getChildValue(child) }}
                    </div>
                    <div
                        class="col-md-6 not-yet-rated"
                        v-else>
                        {{ $t('portfolio.not_assessed') }}
                    </div>
                    <div
                        class="col-md-2"
                        v-if="getChildValue(child) && allGrades">
                        x {{ child.portfolio_rating.weight }}
                    </div>
                    <div
                        class="col-md-2"
                        v-if="allGrades && getChildValue(child)">
                        {{ getChildValue(child) * child.portfolio_rating.weight }}
                    </div>
                </div>

                <div
                    class="row grade-total"
                    v-if="allGrades">
                    <div class="col-md-10 total">
                        {{ $t('portfolio.total') }}
                    </div>
                    <div
                        class="col-md-2"
                        v-if="getWeightedGrade">
                        {{ getWeightedGrade }}
                    </div>
                </div>
            </div>
        </div>

        <div
            class="edit-feedback"
            v-if="canFeedback">
            <label for="feedback-edit">Feedback</label>
            <b-form-textarea
                id="feedback-edit"
                v-model="feedback"
                rows="3"
                max-rows="6"></b-form-textarea>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-portfolio-show-rating-modal-component',
    props: ['ratingIn', 'keyName', 'childTitle', 'childrenIn', 'title', 'feedbackIn', 'canFeedback'],
    data() {
        return {
            grade: this.ratingIn.results && this.ratingIn.results.length ? this.ratingIn.results[0].value : null,
            ovg:
                this.ratingIn.results && this.ratingIn.results.length
                    ? this.ratingIn.results[0].portfolio_rating_option_id
                    : null,
            rating: this.ratingIn,
            children: this.childrenIn,
            feedback: this.feedbackIn ? this.feedbackIn.text : null,
        };
    },
    watch: {
        ratingIn: function (value) {
            this.grade = value.results && value.results.length ? value.results[0].value : null;
            this.ovg = value.results && value.results.length ? value.results[0].portfolio_rating_option_id : null;
            this.rating = value;
        },
        childrenIn: function (value) {
            this.children = value;
        },
        feedbackIn: function (value) {
            this.feedback = value ? this.feedbackIn.text : null;
        },
    },
    computed: {
        disabled() {
            return false;
        },
        filteredChildren() {
            if (!this.children || !this.children.length) {
                return [];
            }
            return this.children.filter((child) => {
                return !!(child.portfolio_rating && child.portfolio_rating.type);
            });
        },
        allGrades() {
            if (!this.children || !this.children.length) {
                return false;
            }
            const children = this.children.filter((child) => {
                return !!(child.portfolio_rating && child.portfolio_rating.type);
            });
            if (!children || !children.length) {
                return false;
            }
            for (const child of children) {
                if (child.portfolio_rating.type !== 2) {
                    return false;
                }
            }
            return true;
        },
        getWeightedGrade() {
            let weight = 0;
            let grade = 0;

            const children = this.children.filter((child) => {
                return !!(
                    child.portfolio_rating &&
                    child.portfolio_rating.type === 2 &&
                    child.portfolio_rating.results.length
                );
            });

            for (const child of children) {
                weight += child.portfolio_rating.weight;
                grade += child.portfolio_rating.weight * child.portfolio_rating.results[0].value;
            }

            return Math.round((grade / weight) * 100) / 100;
        },
    },
    methods: {
        onOk() {
            let data = {
                rating: {
                    rating_id: this.rating.id,
                    value: this.grade,
                    option_id: this.ovg,
                },
                feedback: this.feedback,
            };

            if (this.rating.results && this.rating.results.length) {
                data.rating.result_id = this.rating.results[0].id;
            }

            this.$emit('save-rating', data);
        },
        getChildValue(child) {
            if (!child.portfolio_rating || !child.portfolio_rating.results || !child.portfolio_rating.results.length) {
                return null;
            }

            if (child.portfolio_rating.type === 1) {
                const id = child.portfolio_rating.results[0].portfolio_rating_option_id;
                if (!id) {
                    return null;
                }
                for (const option of child.portfolio_rating.options) {
                    if (option.id === id) {
                        return option.value;
                    }
                }
            }
            if (child.portfolio_rating.type === 2 && child.portfolio_rating.results[0].value) {
                return child.portfolio_rating.results[0].value;
            }

            return null;
        },
        resetOvg() {
            this.ovg = null;
        },

        ovgToggle(id) {
            if (id === this.ovg) {
                this.resetOvg();
            } else {
                this.ovg = id;
            }
        },
    },
};
</script>

<style scoped>
.ovg-rating,
.rating-options,
.grade-rating {
    margin-bottom: 30px;
}

.sub-assignment-rating {
    display: flex;
    justify-content: space-between;
    align-content: center;
}

.not-yet-rated {
    color: #757575;
}

.grade-options {
    margin-bottom: 30px;
}

.grade-options label {
    display: inline-block;
    width: auto;
    margin-right: 15px;
    font-weight: 500;
}

.grade-options .assignment-grade {
    display: inline-block;
    width: 85%;
    padding: 15px;
}

.sub-assignment-grade,
.grade-total {
    margin-top: 15px;
}

.grade-total .total,
.edit-feedback label,
.grades .number,
.grades .weight,
.grades .result {
    font-weight: 500;
}

.grade-total {
    align-items: center;
}
</style>
